import React from 'react';
import AdministrationModuleComponent from "./AdministrationModuleComponent/AdministrationModuleComponent";
import {useAppSelector} from "../../../hooks/redux";
import {getAdditionalModules, getBasicModules} from "../../../store/selectors/ModulesSelectors";
import {EnumModuleTypes} from "../../../enums/EnumModuleTypes";
import LayoutContentWrapper from "../../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import styles from './AdministrationModules.module.css'
import {UXPrice} from "../../../enums/UXText/UXPrice";
import {EnumLanguage} from "../../../enums/EnumLanguage";

const AdministrationModules = () => {

    const basicModules = useAppSelector(getBasicModules)
    // const additionalModules = useAppSelector(getAdditionalModules)

    return (
        <LayoutContentWrapper>
            <div className={styles.wrapper}>
                <AdministrationModuleComponent title={UXPrice.basicVersion.title[EnumLanguage.ru]} modules={basicModules} modulesType={EnumModuleTypes.basic}/>
                {/* <AdministrationModuleComponent title={UXPrice.additionalModules.title[EnumLanguage.ru]} modules={additionalModules} modulesType={EnumModuleTypes.additional}/> */}
            </div>
        </LayoutContentWrapper>

    );
};

export default AdministrationModules;